import React from "react";
import "./style.scss";

interface LinearProgressBarProps {
  percentage: number | string;
}

const LinearProgressBar: React.FC<LinearProgressBarProps> = ({
  percentage,
}) => {
  return (
    <div className="linear-progress">
      <div className="linear-progress__bar">
        <div
          className="linear-progress__fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="linear-progress__value">{percentage}%</span>
    </div>
  );
};

export default LinearProgressBar;
